import {
    Button,
    Checkbox,
    Collapse,
    Dropdown,
    Input,
    Modal,
    Popover,
    Tabs,
} from "antd";
import React, { useEffect, useState } from "react";
import MoreIcon from "../../images/more-horizontal.png";
import EditIcon from "../../images/edit.svg";
import DeleteIcon from "../../images/delete.svg";
import CloseIcon from "../../images/close.svg";
import { toast } from "react-toastify";
import moment from "moment";
import { useLocation } from "react-router-dom";
import axios from "../../helpers/axios";
const { Panel } = Collapse;

const defaultModalValue = { open: false, type: "create", id: "" };
const UserRoles = () => {
    const accessToken = localStorage.getItem("agentModuleToken");
    const location = useLocation();
    //console.log("location", location.state);
    const pagePermission = location.state;
    const [roleModal, setRoleModal] = useState(defaultModalValue);
    const [Roles, setRoles] = useState([]);
    const [RoleItems, setRoleItems] = useState([]);
    const [roleName, setRoleName] = useState("");
    const [RoleList, setRoleList] = useState([]);
    const [RolesCount, setRolesCount] = useState([]);
    const [activeTab, setActiveTab] = useState(
        RolesCount?.length > 0 ? RolesCount[0]?.value : "1"
    );
    const [RoleCollapse, setRoleCollapse] = useState([]);

    const ResetValues = () => {
        setRoleItems(Roles);
        setRoleCollapse(Roles?.map((it) => it?.id))
        setRoleName("");
        GetAllRoles();
        setRoleModal(defaultModalValue);
    };

    const GetAllRoles = async () => {
        const resp = await axios.post(
            "/admin/user-role/list",
            { status: activeTab },
        );
        if (resp?.status < 400) {
            setRolesCount(resp.data?.counts);
            setRoleList(resp?.data.data);
        }
    };
    const GetRoles = async () => {
        const resp = await axios.get("/admin/settings");
        if (resp?.status < 400 && resp.data.data?.permission_modules) {
            setRoles(resp.data.data?.permission_modules);
            setRoleItems(resp.data.data?.permission_modules);
            setRoleCollapse(resp.data.data?.permission_modules?.map((it) => it?.id))

        }
    };

    const GetRoleInfo = async (id) => {
        const resp = await axios.get(`/admin/user-role/info/${id}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
        if (resp?.status < 400) {
            if (resp?.data?.data?.permission_modules?.length > 0) {
                setRoleName(resp.data?.data?.role_name);
                setRoleItems(resp.data?.data?.permission_modules);
                setRoleCollapse(resp.data.data?.permission_modules?.map((it) => it?.id))
                setRoleModal({ open: true, type: "edit", id: id });
            }
        }
    };

    const CreateRolePermissions = async () => {
        const data = {
            role_name: roleName,
            permission_modules: RoleItems,
            status: activeTab,
        };
        if (data?.role_name === "") {
            toast.error("Please Enter Role Name...!");
            return;
        }
        if (roleModal?.type === "edit") {
            const resp = await axios.put(`/admin/user-role/update/${roleModal?.id}`, data, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            if (resp?.data?.resp_code < 400) {
                toast.success(resp?.data?.message);
                ResetValues();
            }
        } else {
            const resp = await axios.post("/admin/user-role/create", data, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            if (resp?.data?.resp_code < 400) {
                toast.success(resp?.data?.message);
                ResetValues();
            }
        }
    };
    const UpdateRoleStatus = async (item, statusValue, id) => {
        const data = {
            role_name: item[0]?.role_name,
            permission_modules: item[0]?.permission_modules,
            status: statusValue,
        };
        const resp = await axios.put(`/admin/user-role/update/${id}`, data, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
        if (resp?.data?.resp_code < 400) {
            toast.success(resp?.data?.message);
            ResetValues();
        }
    };

    const HandleRoleDelete = async (id) => {
        const resp = await axios.delete(`/admin/user-role/delete/${id}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
        if (resp?.status < 400) {
            toast.error(resp?.data?.message);
            GetAllRoles();
        }
    };

    useEffect(() => {
        GetRoles();
        GetAllRoles();
    }, [activeTab]);

    const UpdateRoles = (parentId, ChilId, type, isallTrues) => {
        let newState = [];
        const CurrentItem = RoleItems?.filter((itx) => itx?.id === parentId);
        if (CurrentItem?.length > 0) {
            if (type === "all_permission") {
                newState = CurrentItem[0]?.submodules.map((obj) => {
                    if (obj.id === ChilId) {
                        return {
                            ...obj,
                            [`${type}`]: isallTrues ? 0 : obj[type] == 1 ? 0 : 1,
                            [`create_permission`]: isallTrues ? 0 : obj[type] == 1 ? 0 : 1,
                            [`view_permission`]: isallTrues ? 0 : obj[type] == 1 ? 0 : 1,
                            [`update_permission`]: isallTrues ? 0 : obj[type] == 1 ? 0 : 1,
                            [`delete_permission`]: isallTrues ? 0 : obj[type] == 1 ? 0 : 1,
                        };
                    }
                    return obj;
                });
            } else if (type === "view_permission") {
                newState = CurrentItem[0]?.submodules.map((obj) => {
                    if (obj.id === ChilId) {
                        return {
                            ...obj,
                            [`${type}`]: obj[type] == 1 ? 0 : 1,
                            [`create_permission`]: obj[type] == 0 && 0,
                            [`update_permission`]: obj[type] == 0 && 0,
                            [`delete_permission`]: obj[type] == 0 && 0,
                        };
                    }
                    return obj;
                });
            } else {
                newState = CurrentItem[0]?.submodules.map((obj) => {
                    if (obj.id === ChilId) {
                        return { ...obj, [`${type}`]: obj[type] == 1 ? 0 : 1 };
                    }
                    return obj;
                });
            }
            const CurrentRoleItem = CurrentItem.map((obj) => {
                return { ...obj, submodules: newState };
            });
            const FinalItems = RoleItems.map((obj) => {
                if (obj.id === parentId) {
                    return { ...CurrentRoleItem[0] };
                }
                return obj;
            });
            setRoleItems(FinalItems);
        }
    };

    const GetPanelHeader = (title) => {
        return (
            <div className="flex p-[8px_26px] pr-[60px]">
                <div className="flex items-center gap-[10px] w-[40%]">
                    <label
                        htmlFor="row2head"
                        className="flex gap-[10px] items-center text-black text-[14px] cursor-pointer"
                    >
                        {title.charAt(0).toUpperCase() + title.slice(1)}
                    </label>
                </div>
            </div>
        );
    };
    const GetPanelContent = (parentId, subModules, parentName) => {
        return subModules?.map((it) => (
            <div>
                <div className="flex p-[8px_26px] pr-[60px] pl-[20px]">
                    <div className="flex items-center gap-[10px] w-[36.5%]">
                        <label
                            htmlFor="row3head"
                            className="flex gap-[10px] items-center text-black text-[14px] cursor-pointer"
                        >
                            {/* <Checkbox id="row3head" /> */}
                            {it?.label}
                            <Popover content={"coming soon!"}>
                                <img
                                    src="/images/fi_info.svg"
                                    alt="info"
                                    className="inline-block  cursor-pointer"
                                />
                            </Popover>
                        </label>
                    </div>
                    <div className="w-[63.5%]">
                        <div className="flex items-center justify-between gap-[20px]">
                            {parentName !== "notification" && (
                                <label
                                    htmlFor="row33"
                                    className="flex items-center cursor-pointer gap-[10px] text-black"
                                >
                                    <Checkbox
                                        id={it?.id}
                                        onChange={() =>
                                            UpdateRoles(
                                                parentId,
                                                it?.id,
                                                "all_permission",
                                                it.create_permission == 1 &&
                                                it.update_permission == 1 &&
                                                it.view_permission == 1 &&
                                                it.delete_permission == 1
                                            )
                                        }
                                        checked={
                                            it.create_permission == 1 &&
                                            it.update_permission == 1 &&
                                            it.view_permission == 1 &&
                                            it.delete_permission == 1
                                        }
                                    />
                                    All
                                </label>
                            )}
                            <label
                                htmlFor="row31"
                                className="flex items-center cursor-pointer gap-[10px] text-black"
                            >
                                <Checkbox
                                    id={it?.id}
                                    onChange={() =>
                                        UpdateRoles(parentId, it?.id, "view_permission")
                                    }
                                    checked={it?.view_permission == 1}
                                />
                                View
                            </label>
                            {it?.name !== "loan-application" && parentName !== "notification" && (
                                <label
                                    htmlFor="row31"
                                    className="flex items-center cursor-pointer gap-[10px] text-black"
                                >
                                    <Checkbox
                                        id={it?.id}
                                        onChange={() =>
                                            UpdateRoles(parentId, it?.id, "create_permission")
                                        }
                                        checked={it?.create_permission == 1}
                                        disabled={it?.view_permission !== 1}
                                    />
                                    Create
                                </label>
                            )}
                            {parentName !== "notification" && (
                                <label
                                    htmlFor="row32"
                                    className="flex items-center cursor-pointer gap-[10px] text-black"
                                >
                                    <Checkbox
                                        id={it?.id}
                                        onChange={() =>
                                            UpdateRoles(parentId, it?.id, "update_permission")
                                        }
                                        checked={it?.update_permission == 1}
                                        disabled={it?.view_permission !== 1}
                                    />
                                    Manage
                                </label>
                            )}
                            {parentName !== "notification" && (
                                <label
                                    htmlFor="row33"
                                    className="flex items-center cursor-pointer gap-[10px] text-black"
                                >
                                    <Checkbox
                                        id={it?.id}
                                        onChange={() =>
                                            UpdateRoles(parentId, it?.id, "delete_permission")
                                        }
                                        checked={it?.delete_permission == 1}
                                        disabled={it?.view_permission !== 1}
                                    />
                                    Delete
                                </label>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        ));
    };
    return (
        <div className="min-h-screen bg-[#F5F5F5]">
            <Modal
                centered
                title={
                    roleModal?.type === "edit" ? "Update New Role" : "Create New Role"
                }
                open={roleModal?.open}
                onOk={() => CreateRolePermissions()}
                onCancel={() => {
                    setRoleModal(defaultModalValue);
                    setRoleItems(Roles);
                    setRoleCollapse(Roles?.map((it) => it?.id));
                    setRoleName("");
                }}
                okText={
                    roleModal?.type === "edit" ? "Update Permissions" : "Save Permissions"
                }
                cancelText="Cancel"
                width={710}
                closeIcon={<img src={CloseIcon} className="w-5 h-5" />}
                wrapClassName="userRoleModal"
            >
                <div className="mb-[30px] px-[24px]">
                    <label className="block text-[#495159] text-[13px] font-[600] mb-[8px]">
                        Role
                    </label>
                    <Input
                        className="h-[40px] border-[#C3D2E2!important]"
                        value={roleName}
                        onChange={(e) => setRoleName(e.target.value)}
                    />
                </div>
                <div>
                    <h3 className="text-[14px] font-[600] mb-[10px] px-[24px]">
                        Assign Permission to Roles
                    </h3>
                    <div className="flex bg-[#EDF1F5] p-[8px_26px] pr-[60px]">
                        <div className="flex items-center gap-[10px] w-[40%]">
                            <Checkbox />
                            Module
                        </div>
                        <div className="w-[60%]">Permissions</div>
                    </div>
                    <Collapse
                        activeKey={RoleCollapse}
                        expandIcon={({ isActive }) => (
                            <img
                                src="/images/fi_info.svg"
                                style={{
                                    transform: isActive ? "rotate(0deg)" : "rotate(180deg)",
                                }}
                            />
                        )}
                        className="userRoleAcc"
                        onChange={(val) => {
                            setRoleCollapse(val);
                        }}

                    >
                        {RoleItems?.length > 0 &&
                            RoleItems.map((item) => (
                                <Panel header={GetPanelHeader(item.name)} key={item?.id}>
                                    {item?.submodules?.length > 0 &&
                                        GetPanelContent(item?.id, item?.submodules, item.name)}
                                </Panel>
                            ))}
                    </Collapse>

                </div>
            </Modal>
            <div className="pt-[20px] px-[26px] bg-white">
                <div className="flex items-center gap-[15px] justify-between">
                    <h1 className="text-[20px] font-[700]">Manage Roles</h1>
                    {pagePermission?.create_permission == 1 && (
                        <Button
                            type="primary"
                            className="newAccBtn bg-[#055FFB] rounded-[4px] p-[8px_20px] h-[unset] flex items-center gap-[8px] font-[600]"
                            onClick={() => setRoleModal({ open: true, type: "create", id: "" })}
                        >
                            <span className="text-[23px] font-[400] leading-[5px] relative bottom-[2px]">
                                +
                            </span>
                            <span className="txt_cont">Create New Roles</span>
                        </Button>
                    )}
                </div>
            </div>
            <div className="px-[26px] bg-white border-b border-[#f0f0f0]">
                <Tabs
                    className="userAccTab"
                    defaultActiveKey={activeTab}
                    items={[
                        {
                            key: RolesCount[0]?.value.toString(),
                            label: (
                                <div>
                                    {RolesCount[0]?.label}{" "}
                                    <span className="ml-[7px] badge rounded-[20px] leading-[0] font-[600] text-[11px] bg-[#0660FC] text-white h-[20px] w-[30px] inline-flex items-center justify-center">
                                        {RolesCount[0]?.count}
                                    </span>
                                </div>
                            ),
                        },
                        {
                            key: RolesCount[1]?.value.toString(),
                            label: (
                                <div>
                                    {RolesCount[1]?.label}{" "}
                                    <span className="ml-[7px] badge rounded-[20px] leading-[0] font-[600] text-[11px] bg-[#0660FC] text-white h-[20px] w-[30px] inline-flex items-center justify-center">
                                        {RolesCount[1]?.count}
                                    </span>
                                </div>
                            ),
                        },
                    ]}
                    onChange={(k) => setActiveTab(k)}
                />
            </div>
            {activeTab == "1" ? (
                <ActiveAccounts
                    RoleList={RoleList}
                    HandleRoleDelete={HandleRoleDelete}
                    GetRoleInfo={GetRoleInfo}
                    activeTab={activeTab}
                    UpdateRoleStatus={UpdateRoleStatus}
                    pagePermission={pagePermission}
                />
            ) : (
                <DeActiveAccounts
                    RoleList={RoleList}
                    HandleRoleDelete={HandleRoleDelete}
                    GetRoleInfo={GetRoleInfo}
                    activeTab={activeTab}
                    UpdateRoleStatus={UpdateRoleStatus}
                    pagePermission={pagePermission}

                />
            )}
        </div>
    );
};

const ActiveAccounts = ({
    RoleList,
    HandleRoleDelete,
    GetRoleInfo,
    activeTab,
    UpdateRoleStatus,
    pagePermission
}) => {
    const handleMenuClick = (e, id) => {
        if (e.key == 0) {
            GetRoleInfo(id);
        } else if (e.key == 2) {
            let temp = RoleList?.filter((it) => it?.id == id);
            UpdateRoleStatus(temp, 0, id);
        } else {
            HandleRoleDelete(id);
        }
    };
    const items = [
        {
            label: (
                <div className="flex items-center gap-[10px] text-[#203B50] text-[13px]">
                    <img src={EditIcon} /> Edit Details
                </div>
            ),
            key: "0",
        },
        {
            label: (
                <div className="flex items-center gap-[10px] text-[#203B50] text-[13px]">
                    <img src={EditIcon} />{" "}
                    {activeTab == 1 ? "De-Activate Role" : "Activate Role"}
                </div>
            ),
            key: "2",
        },
        {
            label: (
                pagePermission?.delete_permission == 1 && (
                    <div className="flex items-center gap-[10px] text-[#F80707] text-[13px]">
                        <img src={DeleteIcon} /> Delete
                    </div>
                )
            ),
            key: "1",
        },
    ];
    return (
        <div className="px-[26px] pt-[20px]">
            <div className="bg-white p-[10px] rounded-[10px]">
                <div className="userAcctableBox">
                    <table>
                        <thead>
                            <tr>
                                <th>Role ID</th>
                                <th>Created Date & Time</th>
                                <th>Role Name</th>
                                <th>Permission</th>
                                {pagePermission?.update_permission == 1 && (<th>Action</th>)}
                            </tr>
                        </thead>
                        <tbody>
                            {RoleList?.length > 0 &&
                                RoleList?.map((item) => (
                                    <tr>
                                        <td>{item?.id}</td>
                                        <td>
                                            {moment(item?.created_at).format("DD MMMM YYYY")},{" "}
                                            {moment(item?.created_at).format("HH:mm")}
                                        </td>
                                        <td>{item?.role_name}</td>
                                        <td>
                                            <div className="flex gap-[10px] items-center">
                                                {item?.permission_modules?.length > 0 &&
                                                    item?.permission_modules?.map((it, index) => (
                                                        <>
                                                            {Number(it?.permitted_submodules) > 0 && (
                                                                <span key={index} className="p-[6px] inline-block bg-[#E9EAEB] rounded-[4px] text-[#1B252F] text-[13px] capitalize">
                                                                    {it?.name}
                                                                </span>
                                                            )}
                                                        </>
                                                    ))}
                                            </div>
                                            {/* <span>
                              <img src={EditIcon} />
                              <img src={DeleteIcon} />
                            </span> */}
                                        </td>

                                        <td>
                                            {pagePermission?.update_permission == 1 && (
                                                <Dropdown
                                                    overlayClassName="userAccDropdown"
                                                    menu={{
                                                        items,
                                                        onClick: (e) => {
                                                            handleMenuClick(e, item?.id);
                                                        },
                                                    }}
                                                    trigger={["click"]}
                                                    on
                                                >
                                                    <img
                                                        src={MoreIcon}
                                                        width="22"
                                                        className="cursor-pointer"
                                                    />
                                                </Dropdown>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            {RoleList?.length == 0 && (
                                <tr> <td colspan="5" className="text-center">No records found</td> </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

const DeActiveAccounts = ({
    RoleList,
    HandleRoleDelete,
    GetRoleInfo,
    activeTab,
    UpdateRoleStatus,
    pagePermission
}) => {
    const handleMenuClick = (e, id) => {
        if (e.key == 0) {
            GetRoleInfo(id);
        } else if (e.key == 2) {
            let temp = RoleList?.filter((it) => it?.id == id);
            UpdateRoleStatus(temp, 1, id);
        } else {
            HandleRoleDelete(id);
        }
    };
    const items = [
        {
            label: (
                <div className="flex items-center gap-[10px] text-[#203B50] text-[13px]">
                    <img src={EditIcon} /> Edit Details
                </div>
            ),
            key: "0",
        },
        {
            label: (
                <div className="flex items-center gap-[10px] text-[#203B50] text-[13px]">
                    <img src={EditIcon} />{" "}
                    {activeTab == 1 ? "De-Activate Role" : "Activate Role"}
                </div>
            ),
            key: "2",
        },
        {
            label: (
                pagePermission?.delete_permission == 1 && (
                    <div className="flex items-center gap-[10px] text-[#F80707] text-[13px]">
                        <img src={DeleteIcon} /> Delete
                    </div>
                )
            ),
            key: "1",
        },
    ];
    return (
        <div className="px-[26px] pt-[20px]">
            <div className="bg-white p-[10px] rounded-[10px]">
                <div className="userAcctableBox">
                    <table>
                        <thead>
                            <tr>
                                <th>Role ID</th>
                                <th>Created Date & Time</th>
                                <th>Role Name</th>
                                <th>Permission</th>
                                {pagePermission?.update_permission == 1 && (<th>Action</th>)}
                            </tr>
                        </thead>
                        <tbody>
                            {RoleList?.length > 0 &&
                                RoleList?.map((item) => (
                                    <tr>
                                        <td>{item?.id}</td>
                                        <td>
                                            {moment(item?.created_at).format("DD MMMM YYYY")},{" "}
                                            {moment(item?.created_at).format("HH:mm")}
                                        </td>
                                        <td>{item?.role_name}</td>
                                        <td>
                                            <div className="flex gap-[10px] items-center">
                                                {item?.permission_modules?.length > 0 &&
                                                    item?.permission_modules?.map((it, index) => (
                                                        <>
                                                            {Number(it?.permitted_submodules) > 0 && (
                                                                <span key={index} className="p-[6px] inline-block bg-[#E9EAEB] rounded-[4px] text-[#1B252F] text-[13px] capitalize">
                                                                    {it?.name}
                                                                </span>
                                                            )}
                                                        </>
                                                    ))}
                                            </div>
                                            {/* <span>
                              <img src={EditIcon} />
                              <img src={DeleteIcon} />
                            </span> */}
                                        </td>

                                        <td>
                                            {pagePermission?.update_permission == 1 && (
                                                <Dropdown
                                                    overlayClassName="userAccDropdown"
                                                    menu={{
                                                        items,
                                                        onClick: (e) => {
                                                            handleMenuClick(e, item?.id);
                                                        },
                                                    }}
                                                    trigger={["click"]}
                                                    on
                                                >
                                                    <img
                                                        src={MoreIcon}
                                                        width="22"
                                                        className="cursor-pointer"
                                                    />
                                                </Dropdown>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            {RoleList?.length == 0 && (
                                <tr> <td colspan="5" className="text-center">No records found</td> </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default UserRoles;
